import React, { useState, useEffect } from 'react';
import axios from 'axios';
import StarRating from './StarRating';
import { Star, Loader2 } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Compact rating badge to show on profile cards
const RatingBadge = ({ 
  userId, 
  showOnEmpty = false,
  size = 'md',
  onClick = null,
  className = ''
}) => {
  const [rating, setRating] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadRating();
  }, [userId]);

  const loadRating = async () => {
    try {
      const response = await axios.get(`${API}/users/${userId}/rating`, {
        withCredentials: true
      });
      setRating(response.data);
    } catch (error) {
      console.error('Error loading rating:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return null;
  }

  // User has hidden their rating
  if (rating && !rating.show_rating) {
    return null;
  }

  // No rating yet
  if (!rating || rating.rating_count === 0) {
    if (!showOnEmpty) return null;
    return (
      <div className={`flex items-center gap-1 text-gray-400 text-sm ${className}`}>
        <Star className="h-4 w-4" />
        <span>Nouveau</span>
      </div>
    );
  }

  const sizeClasses = {
    sm: 'text-xs',
    md: 'text-sm',
    lg: 'text-base'
  };

  const BadgeContent = () => (
    <div className={`flex items-center gap-1.5 ${sizeClasses[size]} ${className}`}>
      <div className="flex items-center bg-yellow-50 px-2 py-1 rounded-full border border-yellow-200">
        <Star className="h-3.5 w-3.5 fill-yellow-400 text-yellow-400 mr-1" />
        <span className="font-semibold text-yellow-700">
          {rating.rating_avg?.toFixed(1)}
        </span>
        <span className="text-yellow-600 ml-1">
          ({rating.rating_count})
        </span>
      </div>
    </div>
  );

  if (onClick) {
    return (
      <button 
        onClick={onClick} 
        className="hover:opacity-80 transition-opacity"
        data-testid="rating-badge"
      >
        <BadgeContent />
      </button>
    );
  }

  return <BadgeContent />;
};

export default RatingBadge;
